import { CoreCsvUploadType } from '@repo/csv'

export const BUSINESS_UPLOAD_TYPES: CoreCsvUploadType[] = [
  'nod-add-position',
  'tax-rate',
  'edi-poconf-control',
  'route-stop-sequence',
] as const
